import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'app/app.constants';
import { createRequestOption } from 'app/shared/util/request-util';
import {IEmployee} from '../../shared/model/employee.model';

@Injectable({ providedIn: 'root' })
export class EmployeeService {
  public resourceUrl = SERVER_API_URL + 'api/employees';

  constructor(private http: HttpClient) {}

  create(user: IEmployee): Observable<HttpResponse<IEmployee>> {
    return this.http.post<IEmployee>(this.resourceUrl, user, { observe: 'response' });
  }

  update(user: IEmployee): Observable<HttpResponse<IEmployee>> {
    return this.http.put<IEmployee>(this.resourceUrl, user, { observe: 'response' });
  }

  find(login: string): Observable<HttpResponse<IEmployee>> {
    return this.http.get<IEmployee>(`${this.resourceUrl}/${login}`, { observe: 'response' });
  }

  changePass(id: string, newPass: string): Observable<any> {
    return this.http.post(`${this.resourceUrl}/change-pass`, {},{params:{'id':id,'newPass':newPass}});
  }


  findByUserId(login: string): Observable<HttpResponse<IEmployee>> {
    return this.http.get<IEmployee>(`${this.resourceUrl}/user/${login}`, { observe: 'response' });
  }

  query(req?: any): Observable<HttpResponse<IEmployee[]>> {
    const options = createRequestOption(req);
    return this.http.get<IEmployee[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  queryGetList(req?: any): Observable<HttpResponse<IEmployee[]>> {
    const options = createRequestOption(req);
    return this.http.get<IEmployee[]>(this.resourceUrl+'-list', { params: options, observe: 'response' });
  }

  queryGetListForSuperAdmin(req?: any): Observable<HttpResponse<IEmployee[]>> {
    const options = createRequestOption(req);
    return this.http.get<IEmployee[]>(this.resourceUrl+'-list-superadmin', { params: options, observe: 'response' });
  }


  queryCustomerFilter(req?: any): Observable<HttpResponse<IEmployee[]>> {
    const options = createRequestOption(req);
    return this.http.get<IEmployee[]>(this.resourceUrl+'-customer-filter', { params: options, observe: 'response' });
  }

  delete(login: any): Observable<HttpResponse<any>> {
    return this.http.delete(`${this.resourceUrl}/${login}`, { observe: 'response' });
  }

  authorities(): Observable<string[]> {
    return this.http.get<string[]>(SERVER_API_URL + 'api/users/authorities');
  }
}
